import { normalizeToolName } from './tool-config';

const TRACE_BROWSER_STREAMING_TOOLS = new Set([
  'authenticate',
  'login-tool',
  'get-authentication-details',
  'ai-browser-tool',
]);

export function isTraceBrowserStreamingTool(toolName: string): boolean {
  return TRACE_BROWSER_STREAMING_TOOLS.has(normalizeToolName(toolName));
}
